import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle, Mail } from "lucide-react";

export default function Faq() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/faq").then(({ data }) => setData(data)).catch(() => setData({ faqs: [] })); }, []);

  return (
    <div className="mx-auto max-w-2xl" data-testid="faq-page">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-mint"><HelpCircle className="h-6 w-6 text-emerald-800" /></div>
        <h1 className="font-serif text-3xl font-bold text-emerald-950 sm:text-4xl">Help &amp; FAQ</h1>
      </div>

      {data === null ? <div className="mt-6 space-y-3">{[...Array(5)].map((_, i) => <Skeleton key={i} className="h-14 rounded-xl" />)}</div> : (
        <>
          <Accordion type="single" collapsible className="mt-6 space-y-2" data-testid="faq-list">
            {(data.faqs || []).map((f, i) => (
              <AccordionItem key={i} value={`q${i}`} className="rounded-2xl border border-emerald-900/10 bg-white px-4" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-base font-semibold text-emerald-900 hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-slate-600">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {data.supportEmail && (
            <div className="mt-6 flex items-center justify-between rounded-2xl bg-mint/40 p-4" data-testid="faq-support">
              <div>
                <p className="text-sm font-semibold text-emerald-900">Still need help?</p>
                <p className="text-xs text-slate-500">{data.company || "Nikah Match"} support</p>
              </div>
              <a href={`mailto:${data.supportEmail}`} className="inline-flex items-center gap-1.5 rounded-full bg-emerald-800 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-900" data-testid="faq-email-btn"><Mail className="h-4 w-4" /> Email us</a>
            </div>
          )}
        </>
      )}
    </div>
  );
}
